import { QuoteRequest } from '../../models/services/api/postQuote';
import { ApplianceFormData } from '../../models/form/appliance';
import { log } from '@domgen/shared/utils/log';

export function formatQuoteRequest(formData: ApplianceFormData): QuoteRequest | undefined {
  const { VITE_BRAND_CODE } = import.meta.env;
  if (
    !formData.personalDetails ||
    !formData.applianceDetails ||
    !formData.modelSerial ||
    !formData.purchaseDate ||
    !formData.purchasePrice
  ) {
    return;
  }

  const {
    firstName,
    lastName,
    email,
    phoneNumber,
    address,
    addressLine1,
    subBuilding,
    streetNumber,
    street,
    poBox,
    city,
    regionOrStateCode,
    postalCode,
    externalAVSAddressId,
    isValid,
    merchandiseLocationAddress,
    merchandiseLocationLine1,
    merchandiseLocationSubBuilding,
    merchandiseLocationStreetNumber,
    merchandiseLocationStreet,
    merchandiseLocationPoBox,
    merchandiseLocationCity,
    merchandiseLocationRegionOrStateCode,
    merchandiseLocationPostalCode,
    merchandiseLocationExternalAVSAddressId,
    merchandiseLocationIsValid,
  } = formData.personalDetails;

  if (
    !firstName ||
    !lastName ||
    !email ||
    !phoneNumber ||
    !addressLine1 ||
    !city ||
    !regionOrStateCode ||
    !postalCode ||
    !merchandiseLocationLine1 ||
    !merchandiseLocationCity ||
    !merchandiseLocationRegionOrStateCode ||
    !merchandiseLocationPostalCode
  ) {
    log.error({ message: 'Missing required data for quote request', data: { formData } });
    throw new Error('Missing required data for quote request');
  }

  const quoteRequest: QuoteRequest = {
    customer: {
      firstName,
      lastName,
      email,
      address: {
        addressLine1,
        subBuilding,
        number: streetNumber,
        street,
        poBox,
        concatenatedAddress: address,
        city,
        regionOrStateCode,
        postalCode,
        countryCode: 'USA',
        externalAVSAddressId,
        isValid: isValid ?? false,
      },
      phone: phoneNumber.replace(/[^\d+]/g, ''),
    },
    merchandise: [
      {
        brand: VITE_BRAND_CODE,
        modelNumber: formData.modelSerial.modelNumber as string,
        purchaseDate: formData.purchaseDate.purchaseDate as string,
        purchasePrice: formData.purchasePrice.purchasePrice as string,
        serialNumber: formData.modelSerial.serialNumber as string,
        type: formData.applianceDetails.itemCategory as string,
        address: {
          addressLine1: merchandiseLocationLine1,
          subBuilding: merchandiseLocationSubBuilding,
          number: merchandiseLocationStreetNumber,
          street: merchandiseLocationStreet,
          poBox: merchandiseLocationPoBox,
          concatenatedAddress: merchandiseLocationAddress,
          city: merchandiseLocationCity,
          regionOrStateCode: merchandiseLocationRegionOrStateCode,
          postalCode: merchandiseLocationPostalCode,
          countryCode: 'USA',
          externalAVSAddressId: merchandiseLocationExternalAVSAddressId,
          isValid: merchandiseLocationIsValid ?? false,
        },
      },
    ],
  };

  return quoteRequest;
}
